import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonModule as NimbusCommonModule } from '../../common/common.module';
import { TabsComponent } from './tabs.component';
import { TabButtonComponent } from './tab-button.component';

@NgModule({
  imports: [
    CommonModule,
    NimbusCommonModule
  ],
  declarations: [
    TabsComponent,
    TabButtonComponent
  ],
  exports: [
    TabsComponent
  ],
  providers: []
})
export class TabsModule { }
